import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const MUTATION = gql`
  mutation updateSoftwareRefund($input: VolvoSoftwareRefundInput!) {
    updateSoftwareRefund(input: $input) {
      swdlId
      recordDate
      userId
      refundNumber
      status
      reasonForRefund
      message
      helpRequestId
      downloadReason
      downloadResult
    }
  }
`;

const useUpdateSoftwareRefund = (onCompleted = () => {}) => {
  const [action] = useMutation(MUTATION, {
    onCompleted,
    refetchQueries: ['softwareRefund'],
  });

  return (input: any) => {
    return action({ variables: { input } });
  };
};

export default useUpdateSoftwareRefund;
